import React from "react";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { useSegment } from "analytics/segment";
import { setFilters } from "schedule/actions";
import { useStore } from "schedule/store";

interface SameDayCleansFilterButtonProps {
  className?: string;
}

export const SameDayCleansFilterButton = ({
  className,
}: SameDayCleansFilterButtonProps) => {
  const { track } = useSegment();
  const {
    state: {
      filters: { sameDayCleansOnly },
    },
    dispatch,
  } = useStore();
  return (
    <Button
      className={className}
      selected={!!sameDayCleansOnly}
      onClick={() => {
        track({
          eventName: "same_day_cleans_filter",
          action: "click",
          element: "select",
          props: {
            sameDayCleansOnly: !sameDayCleansOnly,
          },
        });
        dispatch(setFilters({ sameDayCleansOnly: !sameDayCleansOnly }));
      }}
    >
      Same Day
    </Button>
  );
};
